import React, { useState, useEffect, useRef, useCallback } from "react";
import {
  useNavigate,
  useLocation,
  useParams,
  useSearchParams,
} from "react-router-dom";
import { Resizable } from "re-resizable";
import useIdle from "hooks/useIdle";

import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Fab,
  Grid,
  IconButton,
  Paper,
  Stack,
  TextField,
  Tooltip,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Avatar,

} from "@mui/material";
import {
  useForm as useLightForm,
  useLLM,
  useSelectedOrganization,
  useSnackbar,
  useTranslations,
  useDepublishWithWarning,
} from "hooks";
//@ts-ignore
import { getBusinessObject } from "bpmn-js/lib/util/ModelUtil";
import "bpmn-js/dist/assets/diagram-js.css";
import "bpmn-js/dist/assets/bpmn-font/css/bpmn-embedded.css";
// import "bpmn-js-properties-panel/dist/assets/properties-panel.css";
import "bpmn-js/dist/assets/bpmn-js.css";
//@ts-ignore
import ContextPadProvider from "bpmn-js/lib/features/context-pad/ContextPadProvider";
import "diagram-js-minimap/assets/diagram-js-minimap.css";
import {
  SaveOutlined,
  SaveAsOutlined,
  VerifiedOutlined,
  CloudDownloadOutlined,
  CloudUploadOutlined,
  CloudDoneOutlined,
  // ChevronLeft,
  Settings,
  ImportExport,
  DatasetLinkedOutlined,
  Visibility,
  VisibilityOff,
  Close,
  ErrorOutline,
  PersonOutline,
} from "@mui/icons-material";
import UserModel from "model/userModel";
import "./NewProcessModule.css";
import {
  AssociationResponse,
  ExtensionElements,
  ExtensionElementType,
  // ProcessModelType,
} from "../../../../../model/processModel";
import PropertiesView from "./PropertyPanelEditor";
import useBpmnModeler from "../../../../../hooks/useBpmnModeler";
import SaveProcessModelPopUp from "../../components/SaveProcessModelPopUp";
import DropZoneElement from "./DropZoneElement";
import OrganizationPanel from "./OrganizationPanel";
import DialogHeader from "components/dialogs/DialogHeader";
import { Validation, isRequired } from "hooks/useForm";
import { CONSTANTS, getTranslation } from "common";
import { organizationsApi, processmodelsApi } from "api";
import { AssociationDialog, ProcessModelError } from "components";
import InputPopUp from "components/dialogs/InputPopUp";
import { clearLanes } from "common/utilities";
import { Robot } from "hooks/useRobots";
import { ProcessModelSchema } from "components/dialogs";
import { Data } from "components/dialogs/ProcessModelSchema";
import AiDrawer from "components/aiChat/AiDrawer";
import AiFab from "components/aiChat/AiFab";
import useSubscriptionFeatures from "hooks/useSubscriptionFeatures";
import { Save } from "@mui/icons-material";
import useEditingState from "hooks/useEditingState";
import { useSelector } from "react-redux";
import { RootState } from "store";
export interface UsersOfSelectedOrganization extends UserModel {
  id: number;
}

export interface GroupModel {
  idorganization: number;
  id: number;
  icon: string | null;
  name: string;
}

export interface RolesModel {
  name: string;
  id: number;
  icon: string | null;
  idorganization: number;
}

const _getContextPadEntries = ContextPadProvider.prototype.getContextPadEntries;
ContextPadProvider.prototype.getContextPadEntries = function (element: any) {
  const entries = _getContextPadEntries.apply(this, [element]);
  // yet to be determined
  delete entries["lane-divide-three"];
  delete entries["lane-divide-two"];

  return entries;
};

const removeFormat = (xml: string) =>
  xml.replace(/\n|\t/g, '').replace(/>\s+</g, '><').trim();

const generateUniqueName = (baseName: string, existingNames: string[]): string => {
  if (!existingNames.includes(baseName)) {
    return baseName;
  }

  let counter = 1;
  let newName = `${baseName} (${counter})`;

  while (existingNames.includes(newName)) {
    counter++;
    newName = `${baseName} (${counter})`;
  }

  return newName;
};

const NewProcessModule: React.FC = () => {
  const [selectedError, setSelectedError] = useState<number | null>(null);
  const isEditing = useEditingState();
  const navigate = useNavigate();
  const { sendSnack } = useSnackbar();
  const [openSaveAsDialog, setOpenSaveAsDialog] = useState(false);
  const [modelType, setModelType] = useState<number>(0);
  const published = modelType === 1;
  const organization = useSelectedOrganization();
  // NOTE: inOrder to call depublishing api we need to use a ref because we are using this api in an event listener of BPMNJS
  // const modelTypeRef = useRef<any>(true);
  const translations = useTranslations();
  const validations: Validation[] = [
    ({ saveAsName }) =>
      isRequired(saveAsName) || {
        saveAsName: getTranslation(translations, "required"),
      },
  ];
  const {
    values,
    changeHandler,
    isValid,
    errors: lightErrors,
    touched,
  } = useLightForm(
    {
      saveAsName: "",
    },
    validations
  );
  const [errors, setErrors] = useState<any | undefined>([]);
  const [isOverlapChecked, setIsOverlapChecked] = useState<boolean>(false);

  const { pathname, state } = useLocation();
  const { editId } = useParams();
  const [searchParams] = useSearchParams();
  const [schema, setSchema] = useState<Data[]>([]);
  const [mode, setMode] = useState<"create" | "edit">(() => {
    return pathname.includes("insert") ? "create" : "edit";
  });
  const { aiRequestCanUse, bypassSubscription, checkLoading, refreshSubscriptionFeatures } = useSubscriptionFeatures();
  const [shouldShowFlowNodeEditor, setShouldShowFlowNodeEditor] =
    useState<boolean>(false);

  const [processModelId, setProcessModelId] = useState<number | null>()

  const [allUsersOfSelectedOrganization, setAllUsersOfSelectedOrganition] =
    useState<UsersOfSelectedOrganization[]>([]);

  const [allGroupsOfSelectedOrganization, setAllGroupsOfSelectedOrganition] =
    useState<GroupModel[]>([]);

  const [allRolesOfSelectedOrganization, setAllRolesOfSelectedOrganition] =
    useState<RolesModel[]>([]);

  const [allRobotsOfSelectedOrganization, setAllRobotsOfSelectedOrganition] =
    useState<Robot[]>([]);

  const [defineData, setDefineData] = useState<boolean>(false);

  const [shouldShowSaveModelPopup, setShouldShowSaveModelPopup] =
    useState<boolean>(false);

  const [nameModelPopUp, setNameModelPopUp] = useState<boolean>(false);

  const orgPanelPositionRef = useRef<any>("");
  const dropZoneRef = useRef<any>(null);
  const propertPanelResizeRef = useRef<any>();
  const errorElementsRef = useRef<any[]>([]);
  const isSavingRef = useRef(false);
  const [hasValidationErrors, setHasValidationErrors] = useState<boolean>(false);

  const { processModelList } = useSelector((state: RootState) => state.process);
  const [processModelName, setProcessModelName] = useState(() => {
    const baseName = getTranslation(translations, "pm.placeholder.untitledprocessmodel");
    if (pathname.includes("insert")) {
      return generateUniqueName(
        baseName,
        processModelList.map(m => m.name || "")
      );
    }
    return baseName;
  });

  // leave it there still if it is not used we will need it later in the associations dialog
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [associations, setAssociations] = useState<AssociationResponse | null>(
    null
  );
  const getUsername = (user: {
    username?: string;
    firstname?: string;
    lastname?: string;
    email?: string;
  }) => {
    if (user.username) {
      return user.username;
    } else if (user.firstname || user.lastname) {
      return (
        user.firstname +
        (user.firstname && user.lastname ? " " : "") +
        user.lastname
      );
    } else {
      return user.email || "";
    }
  };
  // crea un modello per la realizzazione di un'applicazione mobile android
  const {
    bpmnModeler,
    selectedLane,
    extensionElementsRef,
    extensionSubprocesses,
    extensionElements,
    openDiagram,
    shouldShowDropZoneError,
    currentElementRef,
    handleCanvasViewPort,
    selectedElements,
    currentElement,
    onLaneMouseDown,
    processModelData,
    setProcessModelData,
    primaryPropertiesNameRef,
    setExtensionElementsWithRef,
    originalXml,
    isShapeRemoved,
    setIsShapeRemoved,
    isShapeAdded,
    setIsShapeAdded,
    isParticipantChanged,
    setIsParticipantChanged,
    isElementMoved,
    setIsElementMoved,
  } = useBpmnModeler({
    setUserschema: setSchema,
    selectedDesignerId: state?.designerid,
    getUsername,
    pathname,
    editId: editId ? editId : "",
    setProcessModelName,
    setModelType,
  });

  // Modifica il modello attuale in modo che prima della consegna dell'abito venga aspettato il pagamanto del cliente
  const idToUse = processModelId ?? editId;

  const doDepublish = async () => {
    if (modelType !== 1) return;
    try {
      const { data } = await processmodelsApi.delete(`${idToUse}/depublish`);
      sendSnack({
        message: data.responsemessage,
        type: "success",
      });
      setErrors([]);
      setModelType(0);
    } catch {
    } finally {
    }
  };

  // Active-processes warning: shown only when the BE reports at
  // least one active process on the model. Fails open — if the
  // endpoint is missing, the depublish proceeds immediately.
  const {
    warning: activeProcessesWarning,
    requestWarning,
    confirmWarning,
    cancelWarning,
  } = useDepublishWithWarning({
    onSkip: doDepublish,
    onConfirm: doDepublish,
  });

  const handleDepublishing = async (_shouldEnablePublish: boolean) => {
    if (modelType !== 1) return;
    if (idToUse === undefined) return;
    requestWarning(Number(idToUse));
  };

  const {
    aiAnswers,
    llmInputRef,
    handleSubmit: _handleSubmitLLM,
    openAI,
    setOpenAI,
    loading: LLMLoading,
    modelInputRef,
    stopLLM,
    sessions,
    currentSessionId,
    startNewSession,
    loadSession,
    deleteSession,
    renameSession,
    shareSession,
    currentIdSession,
    handleRetry,
    searchSessions,
    searching,
    refreshSessions,
    modelProvider,
    setModelProvider,
    modelName,
    setModelName,
  } = useLLM("model", true);
  const [isRobotPropertyDialogOpen, setIsRobotPropertyDialogOpen] = useState(false);
  const isRobotDialogOpenRef = useRef(false);
  const [pendingAutosave, setPendingAutosave] = useState(false);
  const [showAutosaveAlerts, setShowAutosaveAlerts] = useState(() => {
    return localStorage.getItem(CONSTANTS.STORE_AUTOSAVE_ALERTS) !== 'false';
  });
  const robotValidationRef = useRef<(() => boolean) | null>(null);

  const [isRobotSwimlane, setIsRobotSwimlane] = useState<boolean>(false);
  const [robotName, setRobotName] = useState<string | null>(null);

  useEffect(() => {
    let element = currentElement;
    if (element?.labelTarget) {
      element = element.labelTarget;
    }

    // if (element && element.type === "bpmn:Lane") {
    if (element && element.type && element.type.startsWith("bpmn:")) {
      // console.log(element.type)
      const bo = getBusinessObject(element);
      if (extensionElements) {
        const robotInSwimlane = extensionElements[bo.id]?.find(
          (participant: any) => participant.idparticipanttype === 4
        );

        if (robotInSwimlane) {
          setIsRobotSwimlane(true);
          setRobotName(robotInSwimlane.name);
        } else {
          setIsRobotSwimlane(false);
          setRobotName(null);
        }
      } else {
        setIsRobotSwimlane(false);
        setRobotName(null);
      }
    } else {
      setIsRobotSwimlane(false);
      setRobotName(null);
    }
  }, [currentElement, extensionElements]);

  const handleDismissAlert = () => {
    localStorage.setItem(CONSTANTS.STORE_AUTOSAVE_ALERTS, 'false');
    setShowAutosaveAlerts(false);
  };

  const handleToggleAlerts = () => {
    const newValue = !showAutosaveAlerts;
    localStorage.setItem(CONSTANTS.STORE_AUTOSAVE_ALERTS, newValue.toString());
    setShowAutosaveAlerts(newValue);
  };
  // console.log(processModelData, "processmodeldata")
  const swimlanes = processModelData.swimlanes || [];
  // console.log(swimlanes)

  const publishedWithProcess = modelType === 1 && processModelData.hasprocess;
  const selectedOrganization = useSelectedOrganization();
  const isAdmin = selectedOrganization?.administrator;
  const handleSubmitLLM = async () => {
    const { xml } = await bpmnModeler.saveXML({
      format: true,
    });
    const participants = [
      ...allGroupsOfSelectedOrganization.map(({ id, name }) => ({
        id,
        name,
        type: 1,
      })),
      ...allRolesOfSelectedOrganization.map(({ id, name }) => ({
        id,
        name,
        type: 2,
      })),
      ...allUsersOfSelectedOrganization.map((a) => ({
        name: getUsername(a),
        id: a.id,
        type: 3,
      })),
      ...allRobotsOfSelectedOrganization.map(({ id, name }) => ({
        id,
        name,
        type: 4,
      })),
    ];
    await _handleSubmitLLM({ xml, participants });
    await refreshSubscriptionFeatures()
  };

  const resetColorsOnDiagram = useCallback(() => {
    if (bpmnModeler) {
      const modeling = bpmnModeler.get("modeling");
      // commented because it was causing problems with colors not being reset properly
      // const elements = bpmnModeler.get("elementRegistry");
      // elements.forEach((el: any) => modeling.setColor(el, null));

      //new logic
      errorElementsRef.current.forEach((el: any) => {
        modeling.setColor(el, null);
      });
      errorElementsRef.current = [];
    }
  }, [bpmnModeler]);

  const getRequestBodyForExtensionElements = useCallback(() => {
    let requestBodyForExtensionElements: Array<ExtensionElementType> = [];
    if (extensionElementsRef.current) {
      Object.keys(extensionElementsRef.current).forEach((key: string) => {
        requestBodyForExtensionElements.push(
          ...extensionElementsRef.current[key]
        );
      });
    }
    return requestBodyForExtensionElements;
  }, [extensionElementsRef]);

  const handleValidation = async (callBack?: () => void) => {
    try {
      if (bpmnModeler) {
        setErrors([]);
        const { xml: currentWorkingProcessModel } = await bpmnModeler.saveXML({
          format: true,
        });

        const { data } = await processmodelsApi.put(`/validate`, {
          entities: processModelData.entities,
          model: currentWorkingProcessModel?.replaceAll("#ff0000", "#000000"),
          extensionelements: getRequestBodyForExtensionElements(),
          extensionsubprocesses: extensionSubprocesses,
          extensionflownodes: processModelData.extensionflownodes,
          extensionswimlanes: processModelData.extensionswimlanes,
          idorganization: selectedOrganization?.id,
          name: processModelName,
          version: 0,
          modeltype: 0,
          creation: processModelData.creation,
          id: idToUse,
          swimlanes: processModelData.swimlanes,
        });
        // console.log(processModelData.swimlanes, processModelData.extensionswimlanes)
        sendSnack({
          message: data.responsemessage,
          type: "success",
        });
        // processModelsRef.current.validatedProcessModel =
        //   currentWorkingProcessModel;
        if (callBack) {
          callBack();
        }
        setErrors([]);
        setHasValidationErrors(false);
      }
    } catch (error: any) {
      if (error?.response?.data?.validation) {
        setErrors(error?.response?.data?.validation ?? []);
        setHasValidationErrors(true);
      } else {
        // console.log(processModelData.swimlanes, processModelData.extensionswimlanes)
        sendSnack({
          message: String(error),
          type: "error",
        });
      }

      return true;
    }
  };

  useEffect(() => {
    let isOverLapEnabled = localStorage.getItem(
      CONSTANTS.STORE_OVERLAP_ENABLED
    );
    if (isOverLapEnabled === "true") {
      setIsOverlapChecked(true);
    } else {
      setIsOverlapChecked(false);
    }
  }, []);

  useEffect(() => {
    return () => setSelectedError(null);
  }, []);

  useEffect(() => {
    callOrganizationAllUsers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (searchParams.get("validate") && bpmnModeler) {
      setTimeout(handleValidation);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams, processModelName]);

  useEffect(() => {
    if (bpmnModeler) {
      const modeling = bpmnModeler.get("modeling");
      const elements = bpmnModeler.get("elementRegistry");
      resetColorsOnDiagram();
      const newErrorElement = errors
        .filter((_: any, ind: number) => ind === selectedError)
        .map((error: any) => {
          return elements.get(error.designerid);
        })
        .filter((_: any) => _);
      if (newErrorElement && newErrorElement.length > 0) {
        for (let el of newErrorElement) {
          modeling.setColor(el, {
            stroke: "red",
          });
        }
        errorElementsRef.current = newErrorElement; //added this line to keep track of error elements
      }
    }
  }, [errors, bpmnModeler, selectedError, resetColorsOnDiagram]);

  const callOrganizationAllUsers = async () => {
    if (!selectedOrganization?.id) return;
    try {
      const promises = [
        organizationsApi.get(`${selectedOrganization?.id}/users`), //HELP
        organizationsApi.get(`${selectedOrganization?.id}/groups?page=1&pagesize=100&p=`), //TEMPORARY
        organizationsApi.get(`${selectedOrganization?.id}/roles?page=1&pagesize=100&p=`), //TEMPORARY
        organizationsApi.get(`${selectedOrganization?.id}/robots`), //I DONT UNDERSTAND HOW IT IS DONE, WHY NOT PAGED BUT STILL WORKING?!??!
      ];

      const [usersresult, groupsresult, rolesresult, robotsresult] =
        await Promise.all(promises);
      setAllUsersOfSelectedOrganition(usersresult?.data?.users);
      setAllGroupsOfSelectedOrganition(groupsresult.data.groups);
      setAllRolesOfSelectedOrganition(rolesresult.data.roles);
      setAllRobotsOfSelectedOrganition(robotsresult.data.robots);
    } catch {
    } finally {
    }
  };

  const inputRef = useRef<HTMLInputElement>(null);
  const handleKeyDown = async (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      //cleanup (claude tip)
      if (nameChangeTimer) {
        clearTimeout(nameChangeTimer);
        setNameChangeTimer(null);
      }

      inputRef.current?.blur();

      if (bpmnModeler && processModelName !== processModelData.name) {
        const { xml } = await bpmnModeler.saveXML({ format: true });
        await saveXml(xml, null, false, false, false); // xml, callback, create_revision, showSnackbar, shouldOpenDiagram
      }
    }
  };

  // console.log(mode)

  const saveOppPosition = (orgId?: number | null, modelId?: number) => {
    let oppPosition = {
      idorganization: orgId,
      modelId: modelId,
      height: orgPanelPositionRef.current,
    };

    const listOfOppPositions = localStorage.getItem(
      CONSTANTS.STORE_OPP_POSITION
    );
    const allValidPositions = listOfOppPositions
      ? JSON.parse(listOfOppPositions)
      : [];

    let prevStoredPosIndex = allValidPositions.findIndex((pos: any) => {
      if (
        pos.idorganization === oppPosition.idorganization &&
        pos.modelId === oppPosition.modelId
      ) {
        return pos;
      }
      return false;
    });

    if (prevStoredPosIndex >= 0) {
      allValidPositions.splice(prevStoredPosIndex, 1, oppPosition);
    } else {
      allValidPositions.push(oppPosition);
    }

    localStorage.setItem(
      CONSTANTS.STORE_OPP_POSITION,
      JSON.stringify(allValidPositions)
    );
  };

  const saveXmlAs = async (xml: string) => {
    let requestBodyForExtensionElements: Array<ExtensionElementType> =
      getRequestBodyForExtensionElements();
    try {
      const uniqueName = generateUniqueName(values.saveAsName, processModelList.map(m => m.name || ""));
      const { data } = await organizationsApi.post(
        `${selectedOrganization?.id}/processmodels`,
        {
          entities: [],
          model: xml.replaceAll("#ff0000", "#000000"),
          extensionelements: requestBodyForExtensionElements,
          extensionflownodes: processModelData.extensionflownodes,
          extensionswimlanes: processModelData.extensionswimlanes,
          extensionsubprocesses: extensionSubprocesses,
          idorganization: selectedOrganization?.id,
          name: uniqueName,
          version: 0,
          modeltype: 0,
          creation: processModelData.creation,
        }
      );
      navigate(`/dashboard/process/edit/${data?.id}`);
      setOpenSaveAsDialog(false);
      // TROVARE SOLUZIONE MIGLIORE DEL LOCATION RELOAD
      // eslint-disable-next-line no-restricted-globals
      // location.reload();
    } catch (e: any) {
    } finally {
    }
  };
  const saveXml = async (
    xml: string,
    callBack: any,
    create_revision: boolean = false,
    showSnackbar: boolean = true,
    shouldOpenDiagram: boolean = false
  ) => {
    //this might be useless since we are already validating this in the RobotPropertiesDialog
    if (robotValidationRef.current && !robotValidationRef.current()) {
      sendSnack({ message: "Please fix robot properties errors before saving.", type: "error" });
      return;
    }
    // const _selectedError = selectedError;
    // resetColorsOnDiagram();
    let requestBodyForExtensionElements: Array<ExtensionElementType> =
      getRequestBodyForExtensionElements();
    if (!processModelName) {
      sendSnack({
        message: getTranslation(
          translations,
          "generic.process_name_cannot_be_empty.caption"
        ),
        type: "error",
      });
      return;
    }
    if (mode === "create") {
      if (isSavingRef.current) return;
      isSavingRef.current = true;
      try {
        const uniqueName = generateUniqueName(processModelName, processModelList.map(m => m.name || ""));

        const { data } = await organizationsApi.post(
          `${selectedOrganization?.id}/processmodels?create_revision=${create_revision}`,
          {
            entities: [],
            model: xml.replaceAll("#ff0000", "#000000"),
            extensionelements: requestBodyForExtensionElements,
            extensionflownodes: processModelData.extensionflownodes,
            extensionswimlanes: processModelData.extensionswimlanes,
            extensionsubprocesses: extensionSubprocesses,
            idorganization: selectedOrganization?.id,
            idfolder: state?.folderId ?? null,
            name: uniqueName,
            version: 0,
            modeltype: 0,
            creation: processModelData.creation,
            userschema: JSON.stringify(schema),
            id: idToUse,
          }
        );
        if (uniqueName !== processModelName) {
          setProcessModelName(uniqueName);
        }
        setProcessModelData((prev) => ({ ...prev, ...data, name: uniqueName }));
        // setEditIdValue(data?.id);

        // processModelsRef.current.editIdValue = data?.id;
        // setExistingModelNames(prev => [...prev, uniqueName]);
        saveOppPosition(selectedOrganization?.id, data.id);
        setMode("edit");
        setProcessModelId(data?.id);
        // console.log(processModelId, "dentro create")
        // if (mode !== "create") { //nel caso dell'autosave
        //   navigate(`/dashboard/process/edit/${trueEditId}`, { replace: true });
        // }
        if (showSnackbar) {
          sendSnack({
            message: data.responsemessage,
            type: "success",
          });
        }
        // processModelsRef.current.savedProcessModel = xml;
        originalXml.current = xml;
        if (callBack) callBack(Number(data?.id));
        setErrors([]);
      } catch (e: any) {
        if (e?.response?.data?.validation) {
          setErrors(e?.response?.data?.validation ?? []);
        }
      } finally {
        isSavingRef.current = false;
      }
    }

    else if (mode === "edit") {
      // console.log(processModelId, "dentro edit")
      if (isSavingRef.current) return;
      isSavingRef.current = true;
      try {
        if (bpmnModeler) {
          const otherModelNames = processModelList.map(m => m.name || "").filter(name => name !== processModelData.name);
          const uniqueName = generateUniqueName(processModelName, otherModelNames);
          const { data } = await processmodelsApi.put<any>(
            `${String(idToUse)}?create_revision=${create_revision}`,
            {
              entities: [],
              idorganization: selectedOrganization?.id,
              model: xml.replaceAll("#ff0000", "#000000"),
              extensionelements: requestBodyForExtensionElements,
              extensionflownodes: processModelData.extensionflownodes,
              extensionswimlanes: processModelData.extensionswimlanes,
              extensionsubprocesses: extensionSubprocesses,
              modeltype: 0,
              name: uniqueName,
              version: 0,
              userschema: JSON.stringify(schema),
              creation: processModelData.creation,
              id: idToUse,
            }
          );

          if (uniqueName !== processModelName) {
            setProcessModelName(uniqueName);
          }

          setMode("edit");
          //sennò salva a nastro quando cambi nome
          setProcessModelData((prev) => ({
            ...prev,
            name: uniqueName,
          }));
          // processModelsRef.current.savedProcessModel = data.model;
          originalXml.current = data.model;
          if (shouldOpenDiagram) {
            openDiagram(data.model, true)
          };
          // bpmnModeler.importXML(data.model);
          saveOppPosition(selectedOrganization?.id, Number(editId));
          // console.log('data.success: ', data.success);
          if (data.responsemessage) {
            if (showSnackbar) {
              sendSnack({
                message: data.responsemessage,
                type: "success",
              });
            }
          }
          if (callBack) {
            callBack(Number(editId));
          }
          setErrors([]);
        }
      } catch (error: any) {
        if (
          error?.response?.data?.entities &&
          error?.response?.data?.activities
        ) {
          setAssociations(error.response.data);
        }
        if (error?.response?.data?.validation) {
          setErrors(error?.response?.data?.validation ?? []);
        }
      } finally {
        // setSelectedError(_selectedError);
        isSavingRef.current = false;
      }
    }
  };

  const publishXml = async () => {
    try {
      if (mode === "edit") {
        const { xml } = await bpmnModeler.saveXML({
          format: true,
        });
        await saveXml(xml, null, true, false, false)
        const { data } = await processmodelsApi.post(`${idToUse}/publish`);
        sendSnack({
          message: data.responsemessage,
          type: "success",
        });
        setErrors([]);
        setModelType(1);
        setHasValidationErrors(false);
      } else {
        sendSnack({
          message: getTranslation(
            translations,
            "generic.save_process_model.before_publish.caption"
          ),
          type: "success",
        });
      }
    } catch (error: any) {
      if (error?.response?.data?.validation) {
        setErrors(error?.response?.data?.validation ?? []);
        setHasValidationErrors(true);
      }
    }
  };

  const exportModel = async (modelName: string) => {
    if (bpmnModeler) {
      const data = await bpmnModeler.saveXML({ format: true });
      var element = document.createElement("a");
      element.setAttribute(
        "href",
        "data:text/plain;charset=utf-8," +
        encodeURIComponent(clearLanes(data.xml || ""))
      );
      element.setAttribute("download", `${modelName}.flw`);

      element.style.display = "none";
      document.body.appendChild(element);

      element.click();

      document.body.removeChild(element);
    }
  };

  function camelToNormal(str: string) {
    return str.replace(/([A-Z])/g, " $1").toLowerCase();
  }

  const getNameOfTheSelectedElement = () => {
    if (currentElementRef.current) {
      const bo = getBusinessObject(currentElementRef.current);
      const isTimerEvent = bo.eventDefinitions && bo.eventDefinitions.length;
      if (isTimerEvent) {
        return `Timer ${camelToNormal(bo.$type.split(":")[1])}`;
      }
      return camelToNormal(bo.$type.split(":")[1]);
    }
    return "";
  };

  const addEncoding = (xml: string) =>
    xml.replace(
      `<?xml version="1.0"?>`,
      `<?xml version="1.0" encoding="UTF-8"?>`
    );

  // const onClickGoBack = () => {
  //   // TODO: se ha modificato qualcosa far vedere il popup per dire sicuro di voler uscire?
  //   // if (saveBtnRef.current.className.includes("save-btn-enable")) {
  //   if (bpmnModeler) {
  //     const parser = new DOMParser();
  //     const serializer = new XMLSerializer();
  //     bpmnModeler.saveXML({ format: false }).then((data: any) => {
  //       const current = removeFormat(
  //         addEncoding(
  //           serializer.serializeToString(
  //             parser.parseFromString(data.xml, "text/xml")
  //           )
  //         )
  //       );
  //       const compare = removeFormat(
  //         addEncoding(
  //           serializer.serializeToString(
  //             parser.parseFromString(originalXml.current, "text/xml")
  //           )
  //         )
  //       );
  //       if (current !== compare) {
  //         setShouldShowSaveModelPopup(true);
  //       } else {
  //         navigate(-1);
  //       }
  //     });
  //   }
  // };

  const onClickValidationBtn = (callBack: () => void): void => {
    handleValidation(callBack);
  };

  const togglePropertyPanel = () => {
    setShouldShowFlowNodeEditor((_) => {
      if (_) {
        propertPanelResizeRef.current.resizable.style.width = "80px";
      } else {
        propertPanelResizeRef.current.resizable.style.width = "250px";
      }
      return !_;
    });
  };
  const closePropertyPanel = () => {
    setShouldShowFlowNodeEditor((_) => {
      propertPanelResizeRef.current.resizable.style.width = "80px";
      return false;
    });
  };
  const onSaveSchema = async (rows: Data[]) => {
    if (mode === "create") {
      setSchema(rows);
      setDefineData(false);
    } else {
      let requestBodyForExtensionElements: Array<ExtensionElementType> =
        getRequestBodyForExtensionElements();
      const { xml } = await bpmnModeler?.saveXML({ format: true });
      setSchema(rows);
      await processmodelsApi.put(String(idToUse), {
        userschema: JSON.stringify(rows),
        entities: [],
        idorganization: selectedOrganization?.id,
        model: xml.replaceAll("#ff0000", "#000000"),
        extensionelements: requestBodyForExtensionElements,
        extensionflownodes: processModelData.extensionflownodes,
        extensionswimlanes: processModelData.extensionswimlanes,
        extensionsubprocesses: extensionSubprocesses,
        modeltype: 0,
        name: processModelName,
        version: 0,
        creation: processModelData.creation,
        id: processModelData.id,
      });
    }
  };

  const handleApplyAi = async (model: string) => {
    await bpmnModeler.importXML(model);
    const result = await processmodelsApi.post<{
      extensionswimlanes: any[];
      extensionsubprocesses: any[];
      extensionflownodes: any[];
      extensionelements: ExtensionElementType[];
    }>("extensions", { model });
    const extensionElements: ExtensionElements = {};
    for (const elem of result.data.extensionelements) {
      if (elem.linkedto in extensionElements) {
        extensionElements[elem.linkedto].push(elem);
      } else {
        extensionElements[elem.linkedto] = [elem];
      }
    }

    setExtensionElementsWithRef(extensionElements);
    setProcessModelData((prev) => ({ ...prev, ...result.data }));

    if (bpmnModeler && modelType !== 1 && !hasValidationErrors) {
      const allModelNames = processModelList.map(m => m.name || "");
      const uniqueName = mode === 'create'
        ? generateUniqueName(processModelName, allModelNames)
        : generateUniqueName(processModelName, allModelNames.filter(name => name !== processModelData.name));
      if (uniqueName !== processModelName) {
        setProcessModelName(uniqueName);
      }
      const { xml } = await bpmnModeler.saveXML({ format: false });
      await saveXml(xml, null, true, false, false); // create_revision = true, showSnackbar = false, shouldOpenDiagram = false
    }
  };

  ///////// Debounce per il salvataggio del nome del modello/////////////
  const [nameChangeTimer, setNameChangeTimer] = useState<NodeJS.Timeout | null>(null);
  const [userHasModifiedName, setUserHasModifiedName] = useState(false);

  // useEffect(() => {
  //   if (nameChangeTimer) {
  //     clearTimeout(nameChangeTimer);
  //   }

  //   if (processModelName === processModelData.name || !userHasModifiedName) {
  //     return;
  //   }

  //   const newTimer = setTimeout(async () => {
  //     if (bpmnModeler && processModelName !== processModelData.name) {
  //       try {
  //         const { xml } = await bpmnModeler.saveXML({ format: true });
  //         await saveXml(xml, null, false, false); // create_revision = false, showSnackbar = false
  //       } catch {
  //       }
  //     }
  //   }, 1000);

  //   setNameChangeTimer(newTimer);
  //   //cleanup (claude tip)
  //   return () => {
  //     if (newTimer) {
  //       clearTimeout(newTimer);
  //     }
  //   };
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [processModelName, processModelData.name, bpmnModeler]);

  //cleanup (claude tip)
  // useEffect(() => {
  //   return () => {
  //     if (nameChangeTimer) {
  //       clearTimeout(nameChangeTimer);
  //     }
  //   };
  // }, [nameChangeTimer]);
  /////////////////////////////////////////////////////////////////////////
  useEffect(() => {
    isRobotDialogOpenRef.current = isRobotPropertyDialogOpen;
  }, [isRobotPropertyDialogOpen]);

  const autosave = () => {
    if (isRobotDialogOpenRef.current) {
      return;
    }

    const hasNameChange = editId && processModelName !== processModelData.name && userHasModifiedName;
    //nel caso aggiungere hasValidationErrors
    if ((modelType === 1) && !hasNameChange)
      return

    //clean name timer
    if (nameChangeTimer) {
      clearTimeout(nameChangeTimer);
      setNameChangeTimer(null);
    }

    const shouldCheckXmlChanges = !isEditing;

    if (!hasNameChange && !shouldCheckXmlChanges) {
      return;
    }

    const delay = hasNameChange ? 1000 : 0; // debounce per name change, immediato per autosave (claude tip)

    const newTimer = setTimeout(async () => {
      if (bpmnModeler) {
        const parser = new DOMParser();
        const serializer = new XMLSerializer();

        try {
          const { xml } = await bpmnModeler.saveXML({ format: false });

          const current = removeFormat(
            addEncoding(
              serializer.serializeToString(
                parser.parseFromString(xml, "text/xml")
              )
            )
          );
          const compare = removeFormat(
            addEncoding(
              serializer.serializeToString(
                parser.parseFromString(originalXml.current, "text/xml")
              )
            )
          );

          const nameChanged = editId && processModelName !== processModelData.name;
          const xmlChanged = current !== compare;

          if (xmlChanged || nameChanged) {
            setPendingAutosave(true);

            //revision solo se ci sono modifiche XML
            const shouldCreateRevision = xmlChanged;

            await saveXml(xml, null, shouldCreateRevision, false, false);
            setPendingAutosave(false);
          }
        } catch {
          setPendingAutosave(false);
        }
      }
    }, delay);

    setNameChangeTimer(newTimer);

    return () => {
      if (newTimer) {
        clearTimeout(newTimer);
      }
    };
  }
  useIdle(1000, autosave);

  useEffect(() => {
    if (isShapeRemoved) {
      autosave();
      setIsShapeRemoved(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isShapeRemoved]);

  useEffect(() => {
    if (isShapeAdded) {
      autosave();
      setIsShapeAdded(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isShapeAdded]);

  useEffect(() => {
    if (isParticipantChanged) {
      autosave();
      setIsParticipantChanged(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isParticipantChanged]);

  useEffect(() => {
    if (isElementMoved) {
      autosave();
      setIsElementMoved(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isElementMoved]);

  useEffect(() => {
    if (isRobotDialogOpenRef.current) {
      return;
    }
    const hasNameChange = editId && processModelName !== processModelData.name && userHasModifiedName;

    if ((modelType === 1 || hasValidationErrors) && !hasNameChange)
      return

    //clean name timer
    if (nameChangeTimer) {
      clearTimeout(nameChangeTimer);
      setNameChangeTimer(null);
    }

    const shouldCheckXmlChanges = !isEditing;

    if (!hasNameChange && !shouldCheckXmlChanges) {
      return;
    }

    const delay = hasNameChange ? 1000 : 0; // debounce per name change, immediato per autosave (claude tip)

    const newTimer = setTimeout(async () => {
      if (bpmnModeler) {
        const parser = new DOMParser();
        const serializer = new XMLSerializer();

        try {
          const { xml } = await bpmnModeler.saveXML({ format: false });

          const current = removeFormat(
            addEncoding(
              serializer.serializeToString(
                parser.parseFromString(xml, "text/xml")
              )
            )
          );
          const compare = removeFormat(
            addEncoding(
              serializer.serializeToString(
                parser.parseFromString(originalXml.current, "text/xml")
              )
            )
          );

          const nameChanged = editId && processModelName !== processModelData.name;
          const xmlChanged = current !== compare;

          if (xmlChanged || nameChanged) {
            setPendingAutosave(true);

            //revision solo se ci sono modifiche XML
            const shouldCreateRevision = xmlChanged;

            await saveXml(xml, null, shouldCreateRevision, false, false);
            setPendingAutosave(false);
          }
        } catch {
          setPendingAutosave(false);
        }
      }
    }, delay);

    setNameChangeTimer(newTimer);

    return () => {
      if (newTimer) {
        clearTimeout(newTimer);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    isEditing,
    processModelName,
    processModelData.name,
    hasValidationErrors,
    userHasModifiedName,
    editId,
    bpmnModeler
  ]);

  return (
    <React.Fragment>
      <AiDrawer
        modelInputRef={modelInputRef}
        variant="persistent"
        LLMLoading={LLMLoading}
        aiAnswers={aiAnswers}
        handleSubmitLLM={handleSubmitLLM}
        llmInputRef={llmInputRef}
        openAI={openAI}
        setOpenAI={setOpenAI}
        handleApplyAi={handleApplyAi}
        canUseAi={aiRequestCanUse || bypassSubscription}
        stopLLM={stopLLM}
        sessions={sessions}
        currentSessionId={currentSessionId}
        startNewSession={startNewSession}
        loadSession={loadSession}
        deleteSession={deleteSession}
        renameSession={renameSession}
        shareSession={shareSession}
        currentIdSession={currentIdSession}
        handleRetry={handleRetry}
        searchSessions={searchSessions}
        searching={searching}
        modelProvider={modelProvider}
        setModelProvider={setModelProvider}
        modelName={modelName}
        setModelName={setModelName}
        refreshSessions={refreshSessions}
      />
      <AiFab openAI={openAI} setOpenAI={setOpenAI} />
      <Box height="100%" display="flex" flexDirection="column">
        <Stack flexWrap="wrap" direction="row" spacing={2} alignItems="center">
          {/* <Button
            variant="outlined"
            size="small"
            startIcon={<ChevronLeft />}
            id="back-button"
            onClick={onClickGoBack}
          >
            {getTranslation(translations, "pm.label.button.goback")}
          </Button> */}
          {pendingAutosave ? (
            <CircularProgress size={20} />
          ) : (
            <Save color="primary" fontSize="small" />
          )}
          <TextField
            inputRef={inputRef}
            onKeyDown={handleKeyDown}
            disabled={!isAdmin}
            className="dashed"
            id="process-name"
            type="text"
            variant="outlined"
            size="small"
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: "20px",
              },
            }}
            value={processModelName}
            onChange={({ target }) => {
              setProcessModelName(target.value);
              setUserHasModifiedName(true); //sennò al mount da 500
            }} label={getTranslation(translations, "pm.label.process_name")}
          />
          {isAdmin && (
            <Stack direction="row" alignItems="center" spacing={2}>
              <Stack
                sx={{
                  backgroundColor: (theme) =>
                    theme.palette.mode === "dark"
                      ? theme.palette.grey[900]
                      : theme.palette.grey[100],
                  p: 0.4,
                }}
                component={Paper}
                direction="row"
                spacing={1}
                alignItems="center"
                justifyContent="center"
                id={"edit-page-actions-container"}
              >
                <Tooltip
                  title={getTranslation(translations, "pm.buttons.action.save.revision")}
                >
                  <span>
                    <IconButton
                      // size="small"
                      onClick={async () => {
                        if (!idToUse) {
                          return
                        }
                        bpmnModeler
                          ?.saveXML({ format: true })
                          .then((data: any) => {
                            saveXml(data.xml, (id: number) => {
                              navigate(`/dashboard/process/edit/${idToUse}`, {
                                replace: true,
                              });
                              if (mode === "create") {
                                // TROVARE SOLUZIONE MIGLIORE DEL LOCATION RELOAD
                                // eslint-disable-next-line no-restricted-globals
                                // location.reload();
                              }
                            }, true);
                          });
                      }}
                      id="save-process-model-btn"
                    >
                      <SaveOutlined color="primary" />
                    </IconButton>
                  </span>
                </Tooltip>
                {/* DUPLICATE BUTTON */}
                {mode === "edit" && (
                  <Tooltip
                    title={getTranslation(translations, "pm.button.save_as")}
                  >
                    <span>
                      <IconButton
                        // size="small"
                        id="saveas-process-model-btn"
                        onClick={() => {
                          if (!idToUse) {
                            return
                          }
                          setOpenSaveAsDialog(true)
                        }}
                      >
                        <SaveAsOutlined color="primary" />
                      </IconButton>
                    </span>
                  </Tooltip>
                )}
                {/* DUPLICATE BUTTON */}

                <Tooltip
                  title={getTranslation(
                    translations,
                    "pm.buttons.action.validate"
                  )}
                >
                  <span>
                    <IconButton
                      // size="small"
                      id="valie-process-model-btn"
                      onClick={() => onClickValidationBtn(() => { })}
                    >
                      <VerifiedOutlined color="primary" />
                    </IconButton>
                  </span>
                </Tooltip>

                <Tooltip
                  title={getTranslation(
                    translations,
                    "pm.buttons.action.publish"
                  )}
                >
                  <span>
                    <IconButton
                      id="publish-btn"
                      disabled={
                        published || publishedWithProcess || mode === "create"
                      }
                      // size="small"
                      onClick={async () => {
                        onClickValidationBtn(publishXml);
                      }}
                    >
                      <CloudUploadOutlined
                        color={published ? "disabled" : "primary"}
                      />
                    </IconButton>
                  </span>
                </Tooltip>
                {!modelType ? (
                  <IconButton
                    // size="small"
                    disabled
                  >
                    <CloudDoneOutlined
                      color={published ? "primary" : "disabled"}
                    />
                  </IconButton>
                ) : (
                  <Tooltip
                    title={getTranslation(
                      translations,
                      "pm.buttons.action.depublish"
                    )}
                  >
                    <span>
                      <IconButton
                        id="depublish-btn"
                        // size="small"
                        onClick={() => handleDepublishing(true)}
                        disabled={activeProcessesWarning.checking}
                      >
                        {activeProcessesWarning.checking ? (
                          <CircularProgress size={20} />
                        ) : (
                          <CloudDownloadOutlined color="primary" />
                        )}
                      </IconButton>
                    </span>
                  </Tooltip>
                )}
                {isAdmin && (
                  <React.Fragment>
                    <Divider orientation="vertical" />
                    <Tooltip
                      title={getTranslation(
                        translations,
                        "pm.button.export_model"
                      )}
                    >
                      <span>
                        <IconButton
                          id={`export-model-btn`}
                          // size="small"
                          onClick={(e) => {
                            e.stopPropagation();
                            setNameModelPopUp(true);
                          }}
                        >
                          <ImportExport color="primary" />
                        </IconButton>
                      </span>
                    </Tooltip>
                    <Tooltip
                      title={getTranslation(
                        translations,
                        "process_model.schema.title"
                      )}
                    >
                      <span>
                        <IconButton
                          id={`define-schema-process-model`}
                          // size="small"
                          onClick={(e) => {
                            e.stopPropagation();
                            setDefineData(true);
                          }}
                        >
                          <DatasetLinkedOutlined color="primary" />
                        </IconButton>
                      </span>
                    </Tooltip>
                  </React.Fragment>
                )}

                {checkLoading ? (
                  <CircularProgress size={20} />
                ) : null}
                {/* AI assistant is opened from the floating action button
                    in the bottom-right corner (see <AiFab />). The
                    subscription-gating previously enforced here has been
                    dropped intentionally: the FAB replaces the old header
                    icon consistently across pages. */}
                <Tooltip title={showAutosaveAlerts ? `${getTranslation(translations, "generic.hide.info.alerts")}` : `${getTranslation(translations, "generic.show.info.alerts")}`}>
                  <span>
                    <IconButton
                      onClick={handleToggleAlerts}
                      color="primary"
                    >
                      {!showAutosaveAlerts ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </span>
                </Tooltip>
              </Stack>
              {checkLoading ? (
                <CircularProgress size={20} />
              ) : (
                !aiRequestCanUse && !bypassSubscription && (
                  <>
                    <Alert
                      id="ai-request-limit-alert"
                      icon={<ErrorOutline fontSize="small" />}
                      sx={{
                        minHeight: 40,
                        alignItems: "center",
                        overflowY: "hidden",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "center",
                        backgroundColor: (theme) =>
                          theme.palette.mode === "dark"
                            ? "rgba(255, 183, 77, 0.10)"
                            : theme.palette.error.light,
                        color: (theme) =>
                          theme.palette.mode === "dark"
                            ? theme.palette.warning.light
                            : theme.palette.error.contrastText,
                        border: "1px solid",
                        borderColor: (theme) =>
                          theme.palette.mode === "dark"
                            ? "rgba(255, 183, 77, 0.42)"
                            : theme.palette.error.main,
                        borderLeftWidth: 4,
                        borderLeftColor: (theme) =>
                          theme.palette.mode === "dark"
                            ? theme.palette.warning.main
                            : theme.palette.error.dark,
                        fontWeight: 600,
                        letterSpacing: 0.2,
                        "& .MuiAlert-icon": {
                          color: "inherit",
                        },
                        "& .MuiAlert-message": {
                          padding: "4px 0",
                        },
                      }}
                      severity="error"
                    >
                      {getTranslation(translations, "ai_request.limit.reached")}
                    </Alert>
                    <Button
                      variant="contained"
                      color="primary"
                      size="small"
                      sx={(theme) => ({
                        ...(theme.palette.mode === "dark" && {
                          bgcolor: "primary.main",
                          color: "primary.contrastText",
                          "&:hover": {
                            bgcolor: "primary.dark",
                          },
                        }),
                      })}
                      onClick={() =>
                        navigate(`/dashboard/organizations/${organization?.id}/billing`, {
                          state: { organizationName: organization?.name },
                        })
                      }
                    >
                      {getTranslation(translations, "generic.upgrade")}
                    </Button>
                  </>
                )
              )}

            </Stack>
          )}
        </Stack>
        {modelType === 1 && showAutosaveAlerts && isAdmin && (
          <Alert
            severity="info"
            sx={{
              alignItems: "center",
              my: 1,
              width: "fit-content",
              fontSize: 10
            }}
            action={
              <Tooltip title={getTranslation(translations, "generic.do_not_show_again.caption")}>
                <span>
                  <IconButton
                    size="small"
                    onClick={handleDismissAlert}
                  >
                    <Close fontSize="small" />
                  </IconButton>
                </span>
              </Tooltip>
            }
          >
            {getTranslation(translations, "alert.info.autosave.disabled")}
          </Alert>
        )}

        <Box sx={{ position: "relative" }} className="pm-dropzone-wrapper">
          {!isAdmin && (
            <Box
              sx={{
                position: "absolute",
                zIndex: 999,
                top: 0,
                bottom: 0,
                left: 0,
                right: 0,
                backgroundColor: "transparent",
              }}
            />
          )}
          <Stack direction="column" width="100%" position="relative">
            <DropZoneElement
              shouldShowDropZoneError={shouldShowDropZoneError}
              onClickEditorCollapse={togglePropertyPanel}
              shouldShowFlowNodeEditor={shouldShowFlowNodeEditor}
              bpmnModeler={bpmnModeler as any}
              dropZoneRef={dropZoneRef}
            />
            {isAdmin && (
              <Box
                sx={{
                  position: isOverlapChecked ? "unset" : "relative",
                  pt: "40px",
                }}
              >
                <ProcessModelError
                  errors={errors}
                  isOverlapChecked={isOverlapChecked}
                  setSelectedError={setSelectedError}
                  selectedError={selectedError}
                />
                <OrganizationPanel
                  extensionElements={extensionElements}
                  handleCanvasViewPort={handleCanvasViewPort}
                  orgPanelPositionRef={orgPanelPositionRef}
                  allRolesOfSelectedOrganization={
                    allRolesOfSelectedOrganization
                  }
                  allGroupsOfSelectedOrganization={
                    allGroupsOfSelectedOrganization
                  }
                  allUsersOfSelectedOrganization={
                    allUsersOfSelectedOrganization
                  }
                  allRobotsOfSelectedOrganization={
                    allRobotsOfSelectedOrganization
                  }
                  getUsername={getUsername}
                  onLaneMouseDown={onLaneMouseDown}
                  selectedLane={selectedLane}
                  isOverlapChecked={isOverlapChecked}
                  setIsOverlapChecked={setIsOverlapChecked}
                />
              </Box>
            )}
          </Stack>
          {isAdmin && (
            <Resizable
              ref={propertPanelResizeRef}
              enable={{
                top: false,
                right: false,
                bottom: false,
                left: shouldShowFlowNodeEditor,
                topRight: false,
                bottomRight: false,
                bottomLeft: false,
                topLeft: false,
              }}
              style={{ marginLeft: 4 }}
              minWidth={80}
              onResizeStop={(...rest) => {
                if (Number(rest[2].style.width.replace("px", "")) < 95) {
                  closePropertyPanel();
                }
              }}
            >
              <Stack
                component={Paper}
                py={2}
                borderRadius={0}
                sx={{ clipPath: "inset(-100px 0px 0px -100px)" }}
                height="100%"
                spacing={1}
                direction="column"
              >
                <Stack
                  direction="row"
                  spacing={2}
                  px={2}
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Fab
                    size="small"
                    color="primary"
                    onClick={togglePropertyPanel}
                  >
                    <Settings id="property-panel-btn" />
                  </Fab>
                  {shouldShowFlowNodeEditor && selectedElements?.length > 0 && (
                    <Typography
                      textTransform="capitalize"
                      fontWeight="bold"
                      color="primary"
                    >
                      {isRobotSwimlane ? robotName : getNameOfTheSelectedElement()}
                    </Typography>
                  )}
                </Stack>
                {shouldShowFlowNodeEditor && (
                  <Box px={2} height={"100%"} sx={{ overflowY: "auto" }}>
                    <PropertiesView
                      modeler={bpmnModeler as any}
                      selectedElements={selectedElements}
                      currentElement={currentElement}
                      extensionElements={extensionElements}
                      processModelData={processModelData}
                      getRequestBodyForExtensionElements={
                        getRequestBodyForExtensionElements
                      }
                      setProcessModelData={setProcessModelData}
                      openDiagram={openDiagram}
                      primaryPropertiesNameRef={primaryPropertiesNameRef}
                      onTriggerAutosave={async () => {
                        if (bpmnModeler) {
                          const { xml } = await bpmnModeler.saveXML({ format: true });
                          await saveXml(xml, null, true, false, false);
                        }
                      }}
                      schema={schema}
                      idToUse={idToUse}
                      robotDialogOpen={setIsRobotPropertyDialogOpen}
                      robotValidationRef={robotValidationRef}
                    />
                  </Box>
                )}
              </Stack>
            </Resizable>
          )}
        </Box>

        <SaveProcessModelPopUp
          shouldShowSaveModelPopup={shouldShowSaveModelPopup}
          setShouldShowSaveModelPopup={setShouldShowSaveModelPopup}
          saveXml={(callBack) => {
            bpmnModeler?.saveXML({ format: true }).then((data: any) => {
              saveXml(data.xml, callBack);
            });
          }}
          processModelName={processModelName}
        />
        <Dialog
          open={activeProcessesWarning.open}
          onClose={cancelWarning}
        >
          <DialogTitle>
            {getTranslation(translations, "pm.depublish.activeProcesses.title")}
          </DialogTitle>
          <DialogContent>
            {activeProcessesWarning.loading ? (
              <Box display="flex" justifyContent="center" py={2}>
                <CircularProgress size={28} />
              </Box>
            ) : (
              <>
                <DialogContentText sx={{ mb: 2 }}>
                  {getTranslation(
                    translations,
                    "pm.depublish.activeProcesses.body"
                  )}
                  {" "}
                  <Box component="span" sx={{ fontWeight: 600 }}>
                    ({activeProcessesWarning.count})
                  </Box>
                </DialogContentText>
                <TableContainer
                  id="depublish-active-processes-table"
                  component={Paper}
                  variant="outlined"
                  sx={{
                    maxHeight: 240,
                    overflowY: "auto",
                    borderRadius: 1,
                  }}
                >
                  <Table size="small" sx={{ minWidth: 320 }}>
                    <TableBody>
                      {activeProcessesWarning.names.map((p) => {
                        const user = p.user ?? p;
                        const fullName =
                          [user.firstname, user.lastname]
                            .map((s) => (s || "").trim())
                            .filter(Boolean)
                            .join(" ") || "";
                        const initials =
                          [user.firstname, user.lastname]
                            .map((s) => s?.trim()?.[0]?.toUpperCase() || "")
                            .join("") || "?";
                        const hasUser = fullName.length > 0;
                        return (
                          <TableRow
                            key={p.id}
                            id={`depublish-active-process-row-${p.id}`}
                            hover
                            sx={{
                              "&:last-of-type td, &:last-of-type th": {
                                borderBottom: 0,
                              },
                            }}
                          >
                            <TableCell sx={{ width: 56, py: 1 }}>
                              <Avatar
                                sx={{
                                  width: 32,
                                  height: 32,
                                  bgcolor: hasUser
                                    ? "primary.main"
                                    : "grey.400",
                                  color: "common.white",
                                  fontSize: 14,
                                  fontWeight: 600,
                                }}
                              >
                                {hasUser ? (
                                  initials
                                ) : (
                                  <PersonOutline fontSize="small" />
                                )}
                              </Avatar>
                            </TableCell>
                            <TableCell sx={{ py: 1 }}>
                              <Typography
                                variant="body2"
                                sx={{ fontWeight: 500 }}
                              >
                                {p.name}
                              </Typography>
                            </TableCell>
                            <TableCell
                              align="right"
                              sx={{ py: 1, whiteSpace: "nowrap" }}
                            >
                              <Typography
                                variant="caption"
                                color={
                                  hasUser ? "text.primary" : "text.secondary"
                                }
                                sx={{ fontStyle: hasUser ? "normal" : "italic" }}
                              >
                                {hasUser
                                  ? fullName
                                  : getTranslation(
                                      translations,
                                      "generic.unassigned.caption"
                                    ) || "Unassigned"}
                              </Typography>
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
              </>
            )}
          </DialogContent>
          <DialogActions>
            <Button
              id="depublish-active-cancel-btn"
              onClick={cancelWarning}
              color="primary"
            >
              {getTranslation(translations, "generic.no.caption")}
            </Button>
            <Button
              id="depublish-active-proceed-btn"
              onClick={confirmWarning}
              color="primary"
              disabled={activeProcessesWarning.loading}
            >
              {getTranslation(translations, "generic.yes.caption")}
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={openSaveAsDialog}
          onClose={() => setOpenSaveAsDialog(false)}
        >
          <form>
            <DialogHeader onClose={() => setOpenSaveAsDialog(false)}>
              {getTranslation(translations, "pm.label.choose_name")}
            </DialogHeader>
            <DialogContent>
              <Grid container mt={0} spacing={2}>
                <Grid item>
                  <TextField
                    id="saveas-field"
                    value={values.saveAsName}
                    onChange={({ target }) =>
                      changeHandler("saveAsName", target.value)
                    }
                    error={Boolean(
                      touched.saveAsName && lightErrors.saveAsName
                    )}
                    helperText={touched.saveAsName && lightErrors.saveAsName}
                    size="small"
                    label={getTranslation(
                      translations,
                      "pm.label.process_name"
                    )}
                  />
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions>
              <Stack direction="row" justifyContent="flex-end" spacing={2}>
                <Button>
                  {getTranslation(translations, "generic.button.cancel")}
                </Button>
                <Button
                  id="saveas-confirm-btn"
                  variant="contained"
                  type="submit"
                  disabled={!isValid}
                  onClick={async (e) => {
                    e.preventDefault();
                    if (bpmnModeler) {
                      const modeling = bpmnModeler.get("modeling");
                      const element = bpmnModeler.get("elementRegistry");
                      const newErrorElement = errors
                        .map((error: any) => {
                          if (error.designerid === "") return undefined;
                          return element.get(error.designerid);
                        })
                        .filter((el: any) => el);

                      modeling.setColor(newErrorElement, null);
                      bpmnModeler
                        .saveXML({ format: true })
                        .then((data: any) => {
                          saveXmlAs(data.xml);
                        });
                    }
                  }}
                >
                  {getTranslation(translations, "pm.button.save_as")}
                </Button>
              </Stack>
            </DialogActions>
          </form>
        </Dialog>
      </Box>
      <ProcessModelSchema
        open={defineData}
        setOpen={setDefineData}
        onSave={onSaveSchema}
        schema={schema}
      />
      <AssociationDialog
        open={associations}
        setOpen={setAssociations}
        onReassociate={(data) => {
          if (data.success) {
            // processModelsRef.current.savedProcessModel = data.model;
            originalXml.current = data.model;
            bpmnModeler?.importXML(data.model);
            if (data.responsemessage) {
              sendSnack({
                message: data.responsemessage,
                type: "success",
              });
            }
            setAssociations(null);
          }
        }}
        getProcessModel={async () => {
          const data = await bpmnModeler?.saveXML({ format: true });
          return {
            entities: [],
            idorganization: selectedOrganization?.id as number,
            model: data?.xml || "",
            extensionelements: getRequestBodyForExtensionElements(),
            extensionflownodes: processModelData.extensionflownodes,
            extensionswimlanes: processModelData.extensionswimlanes,
            extensionsubprocesses: extensionSubprocesses,
            modeltype: 0,
            name: processModelName,
            version: 0,
            creation: processModelData.creation || "",
            id: processModelData.id,
          };
        }}
      />
      <InputPopUp
        labels={{
          title: getTranslation(translations, "generic.model_name.caption"),
          inputLabel: getTranslation(
            translations,
            "generic.insert_model_name.caption"
          ),
        }}
        callback={exportModel}
        open={nameModelPopUp}
        onClose={() => setNameModelPopUp(false)}
      />
    </React.Fragment>
  );
};
export default NewProcessModule;
